import { apiClients } from '@app/services/api/clients'
import { getApiClient } from '@app/utils/apiUtils'
import { parcelVolumeCategory } from '@app/constants/shipperAnalytics'

export default (country, dpId, startMonth, endMonth, category = parcelVolumeCategory.TOTAL_VOLUME) => {
  const client = getApiClient(apiClients, country)
  const url = `1.0/dps/${dpId}/shipper-volumes?start_month=${startMonth}&end_month=${endMonth}&category=${category}`
  return client.get(url)
}
